import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Plans from "@/pages/Plans";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Leads from "@/pages/dashboard/Leads";
import LeadDetail from "@/pages/dashboard/LeadDetail";
import Conversations from "@/pages/dashboard/Conversations";
import Sequences from "@/pages/dashboard/Sequences";
import Settings from "@/pages/dashboard/Settings";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#5c5c5c]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route
                path="/app"
                element={
                  <Protected>
                    <DashboardLayout />
                  </Protected>
                }
              >
                <Route index element={<Overview />} />
                <Route path="leads" element={<Leads />} />
                <Route path="leads/:id" element={<LeadDetail />} />
                <Route path="conversations" element={<Conversations />} />
                <Route path="sequences" element={<Sequences />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              {/* Catch-all: never leave the user on a blank screen for an unknown URL */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
